import React, { useMemo } from "react";
import { stringifyUrl } from "query-string";
import { Link, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

import { CompaniesResult } from "@/app/pages/businessDirectory/IBusinessDirectory";
import { usePageURL } from "@/shared/customHooks";
import { isNotUndefinedOrNull, setCompanyInfoCookie } from "@/shared/FunctionCore";
import {CompanyInformationForCookie} from "@/app/pages/businessDirectory/IBusinessDirectory"

interface AutocompleteSearchProps {
  typeAheadResponse: CompaniesResult | undefined;
  showTypeahead: boolean;
  setShowTypeahead: (flag: boolean) => void;
  getShowMoreData: () => void;
}

const AutocompleteSearch = ({
  typeAheadResponse,
  showTypeahead,
  setShowTypeahead,
  getShowMoreData,
}: AutocompleteSearchProps): JSX.Element => {
  const { t } = useTranslation();
  const { countryCode } = usePageURL();

  const showAutocompleteContainer: boolean = useMemo(
    () =>
      showTypeahead &&
      (typeAheadResponse !== null || typeAheadResponse !== undefined),
    [showTypeahead, typeAheadResponse]
  );

  const businessCreditReportsLinkLocalized: string = t(
    "businessDirectory.businessCreditReportsLink"
  );

  // const navigateCompanyProfile = (event, companyProfileLink) => {
  //   event.preventDefault();
  //   let companyId =
  //     companyProfileLink.split("/")[companyProfileLink.split("/").length - 1];
  //   navigate(`/de-de/firmenverzeichnis/${companyId}.html`);
  // };

  // const getCompanyProfileRedirectionLink = (companyProfileLink) => {
  //   let companyHash =
  //     companyProfileLink.split("/")[companyProfileLink.split("/").length - 1];
  //   return `/de-de/firmenverzeichnis/${companyHash}.html`;
  // };

  return (
    <>
      <div
        className={`autocompleteContainer showAutocompleteContainer-${showAutocompleteContainer}`}
      >
        <div className="autocompleteInnerWrapper">
          {typeAheadResponse ? (
            typeAheadResponse.returnResults === 0 ? (
              <div className="no-result-content">
                <div className="noResultLabel1">
                {t("businessDirectory.typeaheadNoResultLabel1") ?? "Sorry, no results were found in the company directory."}
                </div>

                <div>
                  <span className="noResultLabel2">
                  {t("businessDirectory.typeaheadNoResultLabel2") ?? "Is your company not listed?"}
                  </span>

                  <a
                    className="getDunsNumberLabel"
                    href= {t("businessDirectory.typeaheadGetDunsNumberLink")}
                  >
                     {t("businessDirectory.typeaheadGetDunsNumberLabel") ?? "Apply for a D-U-N-S number"}
                  </a>
                </div>
              </div>
            ) : (
              <>
                {typeAheadResponse &&
                  typeAheadResponse.companies.length > 0 &&
                  typeAheadResponse.companies.slice(0, 5).map((co, nu) => {
                    const {
                      countryRegion,
                      duns,
                      primaryName,
                      tradeStyleNames,
                      companyProfileLink,
                      companyInformationForCookie
                    } = co;

                    let companyInformationForCookies: CompanyInformationForCookie;
                    if(isNotUndefinedOrNull(companyInformationForCookie)) {
                      companyInformationForCookies = companyInformationForCookie
                    };

                    const {
                      businessCreditLabel,
                      businessCreditLink,
                      companyProfileLinkLabel,
                    } = typeAheadResponse;

                    return (
                      <div className="li-container" key={nu}>
                        <Link
                          className="companyLink"
                          to={companyProfileLink?.endsWith('.html') ? companyProfileLink : `${companyProfileLink}.html`}
                        >
                          <div>
                            <div className="company-info">{primaryName}</div>

                            <div className="trade-style-names">
                              {tradeStyleNames}
                            </div>

                            <div className="address">{countryRegion}</div>
                          </div>
                        </Link>

                        <div className="url-content">
                          <Link
                             to={companyProfileLink?.endsWith('.html') ? companyProfileLink : `${companyProfileLink}.html`}
                          >
                            <span>
                              {t("businessDirectory.companyProfileTypeahead") ??
                                companyProfileLinkLabel}{" "}
                            </span>
                          </Link>
                          <span className="divider">|</span>

                          <a 
                            href={ countryCode == 'de' || countryCode == 'at' ?  `${t("businessDirectory.businessCreditLink")}${duns}` :  `${t("businessDirectory.businessCreditReportsLink")}`}
                            onClick={() => setCompanyInfoCookie(companyInformationForCookies)}
                          >
                            {t("businessDirectory.businessCreditReport") ??
                              businessCreditLabel}
                          </a>
                        </div>

                        <hr />
                      </div>
                    );
                  })}

                {typeAheadResponse.companies && typeAheadResponse.companies.length >= 1 && <div className="showMoreWrapper">
                  <button
                    className="showMoreButton"
                    onClick={() => {
                      setShowTypeahead(false);
                      getShowMoreData();
                    }}
                    type="button"
                  >
                    {t("businessDirectory.showMoreTypeahead") ?? "Show more"}
                  </button>
                </div>}
              </>
            )
          ) : (
            <></>
          )}
        </div>
      </div>
    </>
  );
};

export default AutocompleteSearch;
